module.exports = __webpack_public_path__ + "img/液冷储能.a3a85788.png";